import { Bucket } from '../../../types/analytics';

/**
 * Chart colours for booking states. Validated with the dataviz palette
 * validator (light surface): lightness band, chroma floor, CVD separation and
 * normal-vision floor all pass. The gold sits under 3:1 contrast, so every
 * chart that uses it ships a legend and a table view.
 */
export const BUCKET_COLOR: Record<Bucket, string> = {
  completed: '#4E8B57',
  upcoming: '#C9962E',
  held: '#B5573C',
  released: '#9a9d99',
  pending: '#9a9d99',
};

export const BUCKET_LABEL: Record<Bucket, string> = {
  completed: 'Completed',
  upcoming: 'Upcoming',
  held: 'Held (late cancel, billed)',
  released: 'Released',
  pending: 'Pending approval',
};

export const BUCKET_HELP: Record<Bucket, string> = {
  completed: 'Already happened. Realized.',
  upcoming: 'Scheduled. Can still shrink, move or cancel.',
  held: 'Cancelled inside the window. Room kept and billed.',
  released: 'Cancelled and freed. Never billed.',
  pending: 'Waiting for the clinician to approve. Not billed.',
};

export const fmtHours = (h: number): string => {
  const rounded = Math.round(h * 100) / 100;
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(rounded * 10 % 1 === 0 ? 1 : 2)} h`;
};

export const fmtMoney = (n: number): string =>
  n.toLocaleString('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0 });

export const fmtPct = (n: number | null | undefined): string =>
  n === null || n === undefined ? 'n/a' : `${Math.round(n * 100)}%`;

export const fmtNotice = (h: number | null): string => {
  if (h === null) return 'n/a';
  if (h < 0) return 'after start';
  if (h < 48) return `${Math.round(h)} h`;
  return `${Math.round(h / 24)} d`;
};

export const periodLabel = (period: string): string =>
  new Date(`${period}-01T12:00:00`).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

export const shiftPeriod = (period: string, delta: number): string => {
  const [y, m] = period.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export const currentPeriod = (): string => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export const downloadCsv = (filename: string, rows: (string | number | null)[][]): void => {
  const esc = (v: string | number | null) => {
    const s = v === null ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const blob = new Blob([rows.map(r => r.map(esc).join(',')).join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
};
